import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function humanize(s: string): string {
  return s.replace(/_/g, " ")
}

/** Format a duration in seconds as `m:ss`. */
export function formatElapsed(totalSeconds: number): string {
  const s = Math.max(0, Math.floor(totalSeconds))
  const m = Math.floor(s / 60)
  const rem = s % 60
  return `${m}:${rem.toString().padStart(2, "0")}`
}

/** 0..1 accuracy ratio rendered as an integer percent. */
export function formatPct(ratio: number): number {
  return Math.round(ratio * 100)
}

/**
 * Unbiased in-place-copy Fisher-Yates shuffle. Returns a new array; the input is
 * not mutated. Single owner for the QUESTION-DRAW shuffles: the exam pool draw
 * (lib/exam/session.ts) and the practice draw (lib/questions/practice.ts).
 *
 * NOT the only shuffle in the repo, and deliberately so. Option ORDER WITHIN a
 * question is shuffled by `shuffleInPlace` in
 * packages/scenarios/src/client-question.ts, which is slug-seeded and
 * deterministic. It cannot call this one: `packages/*` may not import from
 * `apps/*`, and this is `Math.random`-backed, which would reshuffle on every
 * reload and desync post-submit feedback from the letters the student answered.
 */
export function shuffle<T>(arr: readonly T[]): T[] {
  const out = [...arr]
  for (let i = out.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[out[i], out[j]] = [out[j]!, out[i]!]
  }
  return out
}

/**
 * "used / max" for a capped text input once 80% of the cap is used, else null:
 * short boxes stay clean, and a paste the cap truncated reads as `max / max`.
 * Locale pinned so the string is deterministic.
 */
export function charCounterText(length: number, max: number): string | null {
  if (length < max * 0.8) return null
  return `${length.toLocaleString("en-US")} / ${max.toLocaleString("en-US")}`
}
